import React from 'react';
import autorzy from '../data/autorzyGrafik.json';

/**
 * Podpis pod grafiką: autor, licencja, odnośnik do źródła.
 *
 * To NIE jest ozdoba. Zdjęcia aut pochodzą z Wikimedia Commons i niemal
 * wszystkie są na licencjach CC BY / CC BY-SA, które **wymagają** podania
 * autora. Publikacja bez podpisu łamie warunki, na jakich wolno nam ich
 * używać — dlatego podpis renderuje się automatycznie, a nie na życzenie.
 *
 * Dane pochodzą z `data/autorzyGrafik.json`, generowanego ze skryptu
 * pobierania (`wallbox_scraper/pobierz_grafiki_aut.py --atrybucja`).
 * Podmieniasz plik graficzny ręcznie? Popraw też wpis — inaczej przypiszesz
 * nowe zdjęcie cudzemu autorowi.
 *
 * Brak wpisu = brak podpisu. To świadome: własne zdjęcie albo grafika
 * z domeny publicznej podpisu nie potrzebuje.
 *
 * Pole `podpis` zastępuje całą linię i pomija przedrostek „fot.". Jest po to,
 * że biura prasowe producentów narzucają DOSŁOWNE brzmienie podpisu
 * („Photo courtesy of Volvo Car USA”) i doklejanie do niego czegokolwiek
 * łamie warunek, na jakim udostępniły zdjęcie.
 */
const PodpisGrafiki = ({ sciezki, className = '' }) => {
  const lista = Array.isArray(sciezki) ? sciezki : [sciezki];
  const klucz = lista
    .filter(Boolean)
    .map((s) => String(s).replace(/^\//, ''))
    .find((s) => autorzy[s]);

  if (!klucz) return null;
  const { autor, licencja, zrodlo, podpis } = autorzy[klucz];
  const styl = `text-[10px] leading-tight text-gray-400 ${className}`;

  if (podpis) {
    return (
      <p className={styl}>
        {zrodlo ? (
          <a href={zrodlo} target="_blank" rel="noreferrer noopener" className="hover:text-gray-600 hover:underline">
            {podpis}
          </a>
        ) : podpis}
      </p>
    );
  }

  return (
    <p className={styl}>
      fot. {zrodlo ? (
        <a href={zrodlo} target="_blank" rel="noreferrer noopener" className="hover:text-gray-600 hover:underline">
          {autor}
        </a>
      ) : autor}
      {licencja ? `, ${licencja}` : ''}
    </p>
  );
};

export default PodpisGrafiki;
